var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgError = function SvgError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FE4B58",
    d: "M8 2.667a5.333 5.333 0 1 0 0 10.666A5.333 5.333 0 0 0 8 2.667M1.333 8a6.667 6.667 0 1 1 13.333 0A6.667 6.667 0 0 1 1.333 8m3.862-2.805c.26-.26.682-.26.943 0L8 7.057l1.862-1.862a.667.667 0 1 1 .942.943L8.942 8l1.862 1.862a.667.667 0 1 1-.942.943L8 8.943l-1.862 1.862a.667.667 0 1 1-.943-.943L7.057 8 5.195 6.138a.667.667 0 0 1 0-.943"
  })));
};
export default SvgError;